import http from "./index.js";
import store from "@/store/index.js";
import mixin from "@/mixin/index.js";
const storageKey = "vetalfa_support_visitor";
let generation = 0;
let sessionRequest = null;
const identity = () => (store.getters["general/user"] || {}).uid || "";
const authenticated = () => !!identity();
const readSession = () => {
  try {
    const data = window.sessionStorage.getItem(storageKey);
    const session = data ? mixin.methods._decrypt(data) : null;
    return session &&
      typeof session.visitorToken === "string" &&
      session.visitorToken
      ? session
      : null;
  } catch (_) {
    return null;
  }
};
async function credentials() {
  if (authenticated()) return { hasToken: true };
  let session = readSession();
  if (!session) {
    if (!sessionRequest) {
      const epoch = generation;
      const request = http
        .postAsync({ url: "/support/session", body: {} })
        .then(result => {
          if (epoch !== generation || authenticated())
            throw new Error("Sessão alterada");
          window.sessionStorage.setItem(
            storageKey,
            mixin.methods._encrypt(result)
          );
          return result;
        })
        .finally(() => {
          if (sessionRequest === request) sessionRequest = null;
        });
      sessionRequest = request;
    }
    session = await sessionRequest;
  }
  return { headers: { "x-support-visitor": session.visitorToken } };
}
export function clearSupportSession() {
  generation += 1;
  sessionRequest = null;
  try {
    window.sessionStorage.removeItem(storageKey);
  } catch (_) {
    /* Storage may be disabled. */
  }
}
export function supportId() {
  const bytes = new Uint8Array(16);
  window.crypto.getRandomValues(bytes);
  return Array.from(bytes, value => value.toString(16).padStart(2, "0")).join(
    ""
  );
}
async function call(method, path, body) {
  const epoch = generation;
  const uid = identity();
  const current = () => epoch === generation && uid === identity();
  try {
    const auth = await credentials();
    if (!current()) throw new Error("Sessão alterada");
    const result = await http[method]({
      url: "/support" + path,
      body,
      ...auth
    });
    if (!current()) throw new Error("Sessão alterada");
    return result;
  } catch (error) {
    if (!uid && current() && error.response && error.response.status === 401) {
      clearSupportSession();
      window.dispatchEvent(new CustomEvent("vetalfa:support-session-expired"));
    }
    throw error;
  }
}
export default {
  get(path) {
    return call("getAsync", path);
  },
  post(path, body) {
    return call("postAsync", path, body);
  }
};
